import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon, FilterIcon, EyeIcon, EditIcon, CopyIcon, MoreHorizontalIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
const Templates = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const templates = [{
    id: '1',
    name: 'Monthly Update',
    description: 'Standard template for monthly newsletters',
    status: 'active',
    createdBy: 'Admin User',
    createdDate: 'Apr 15, 2023',
    lastModified: 'May 10, 2023'
  }, {
    id: '2',
    name: 'Welcome Series',
    description: 'First email for new entrepreneurs',
    status: 'active',
    createdBy: 'Content Editor',
    createdDate: 'Mar 22, 2023',
    lastModified: 'May 5, 2023'
  }, {
    id: '3',
    name: 'Promotional',
    description: 'Template for special offers and promotions',
    status: 'active',
    createdBy: 'Marketing Team',
    createdDate: 'Feb 10, 2023',
    lastModified: 'Apr 28, 2023'
  }, {
    id: '4',
    name: 'Event Invitation',
    description: 'For workshops and networking events',
    status: 'inactive',
    createdBy: 'Admin User',
    createdDate: 'Jan 5, 2023',
    lastModified: 'Mar 15, 2023'
  }, {
    id: '5',
    name: 'Survey Template',
    description: 'For collecting feedback from entrepreneurs',
    status: 'inactive',
    createdBy: 'Research Team',
    createdDate: 'May 1, 2023',
    lastModified: 'May 2, 2023'
  }];
  const filteredTemplates = templates.filter(template => {
    const matchesSearch = template.name.toLowerCase().includes(searchQuery.toLowerCase()) || template.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || template.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  return <div className="space-y-6" data-id="element-653">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-654">
        <h2 className="text-2xl font-bold text-secondary-900" data-id="element-655">Templates</h2>
        <Link to="/templates/create" className="btn btn-primary flex items-center justify-center mt-3 sm:mt-0" data-id="element-656">
          <PlusIcon size={16} className="mr-1" data-id="element-657" />
          <span data-id="element-658">Create Template</span>
        </Link>
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-659">
        <div className="relative flex-1 max-w-md" data-id="element-660">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-661">
            <SearchIcon size={18} className="text-secondary-400" data-id="element-662" />
          </div>
          <input type="text" placeholder="Search templates..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 input" data-id="element-663" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-664">
          <div className="flex items-center space-x-2" data-id="element-665">
            <FilterIcon size={16} className="text-secondary-500" data-id="element-666" />
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-secondary-300 rounded-md text-secondary-700 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500" data-id="element-667">
              <option value="all" data-id="element-668">All Status</option>
              <option value="active" data-id="element-669">Active</option>
              <option value="inactive" data-id="element-670">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      <div className="table-container" data-id="element-671">
        <table className="table" data-id="element-672">
          <thead className="table-header" data-id="element-673">
            <tr data-id="element-674">
              <th className="table-header-cell" data-id="element-675">Template Name</th>
              <th className="table-header-cell" data-id="element-676">Description</th>
              <th className="table-header-cell" data-id="element-677">Status</th>
              <th className="table-header-cell" data-id="element-678">Created By</th>
              <th className="table-header-cell" data-id="element-679">Created Date</th>
              <th className="table-header-cell" data-id="element-680">Last Modified</th>
              <th className="table-header-cell" data-id="element-681">Actions</th>
            </tr>
          </thead>
          <tbody className="table-body" data-id="element-682">
            {filteredTemplates.map(template => <tr key={template.id} className="table-row" data-id="element-683">
                <td className="table-cell font-medium" data-id="element-684">{template.name}</td>
                <td className="table-cell" data-id="element-685">{template.description}</td>
                <td className="table-cell" data-id="element-686">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${template.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-secondary-100 text-secondary-800'}`} data-id="element-687">
                    {template.status === 'active' ? <CheckCircleIcon size={12} className="mr-1" data-id="element-688" /> : <XCircleIcon size={12} className="mr-1" data-id="element-689" />}
                    {template.status.charAt(0).toUpperCase() + template.status.slice(1)}
                  </span>
                </td>
                <td className="table-cell" data-id="element-690">{template.createdBy}</td>
                <td className="table-cell" data-id="element-691">{template.createdDate}</td>
                <td className="table-cell" data-id="element-692">{template.lastModified}</td>
                <td className="table-cell" data-id="element-693">
                  <div className="flex items-center space-x-2" data-id="element-694">
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Preview" data-id="element-695">
                      <EyeIcon size={16} data-id="element-696" />
                    </button>
                    <Link to={`/templates/edit/${template.id}`} className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Edit" data-id="element-697">
                      <EditIcon size={16} data-id="element-698" />
                    </Link>
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Clone" data-id="element-699">
                      <CopyIcon size={16} data-id="element-700" />
                    </button>
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="More options" data-id="element-701">
                      <MoreHorizontalIcon size={16} data-id="element-702" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default Templates;